import './index.css';
import 'config/localization/i18n';
import reportWebVitals from './reportWebVitals';

import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as AxiosConfig from './config/init/axios';
import * as LanguageConfig from './config/init/language';

import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const Initialization = () => {

  useEffect(() => {
    let apiRequestListener = AxiosConfig.setupAPIRequestListener();
    let apiResponseListener = AxiosConfig.setupAPIResponseListener();
    LanguageConfig.reloadResources();
    return () => {
      AxiosConfig.removeAPIRequestListener(apiRequestListener);
      AxiosConfig.removeAPIResponseListener(apiResponseListener);
    };
  }, []);
  return <></>
}

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

root.render(
  <>
    {/* <React.StrictMode> */}
    <BrowserRouter>
      <Initialization />
      <App />
    </BrowserRouter>
    {/* </React.StrictMode> */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
